<script lang="ts">
  import Icon from '@iconify/svelte'

  interface Props {
    title?: string;
    message: string;
    status: number;
    showHomeLink?: boolean;
  }

  let {
    title = 'Error',
    message,
    status,
    showHomeLink = true
  }: Props = $props();
</script>

<div class="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
  <div class="w-full max-w-md space-y-8 text-center">
    <div class="rounded-md bg-red-50 p-8">
      <div class="flex flex-col items-center">
        <div class="flex shrink-0 flex-col items-center">
          <div class="relative">
            <div class="rounded-full border-4 border-red-400 p-6">
              <svg viewBox="0 0 100 40" class="h-12">
                <text
                  x="50%"
                  y="50%"
                  text-anchor="middle"
                  dominant-baseline="middle"
                  class="fill-red-400 font-mono text-2xl font-bold"
                >
                  {status}
                </text>
              </svg>
            </div>
            <div class="absolute -bottom-2 right-0 rounded-full bg-red-50 p-1">
              {#if status >= 500}
                <Icon icon="heroicons:server" class="h-6 w-6 text-red-400" />
              {:else if status === 404}
                <Icon icon="heroicons:question-mark-circle" class="h-6 w-6 text-red-400" />
              {:else if status === 403}
                <Icon icon="heroicons:lock-closed" class="h-6 w-6 text-red-400" />
              {:else if status === 401}
                <Icon icon="heroicons:key" class="h-6 w-6 text-red-400" />
              {:else}
                <Icon icon="heroicons:exclamation-triangle" class="h-6 w-6 text-red-400" />
              {/if}
            </div>
          </div>
        </div>
        <div class="mt-4">
          <h3 class="text-lg font-medium text-red-800">{title}</h3>
          <div class="mt-2 text-sm text-red-700">
            <p>{message || "Something unexpected happened. We're looking into it - please try again in a moment."}</p>
          </div>
          {#if showHomeLink}
            <div class="mt-6">
              <a
                href="/"
                class="text-primary hover:text-primary-dark inline-flex items-center gap-2 text-sm font-medium"
              >
                <Icon icon="heroicons:arrow-left" class="h-4 w-4" />
                Back to Home
              </a>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
